import * as _ from 'underscore';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Item } from 'react-contexify';
import { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';

import CopyIcon from '@material-ui/icons/FileCopy';
import PasteIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import DeleteIcon from '@material-ui/icons/Delete';

import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import Console from '../../../lib/debug';

class CalendarContextMenu extends Component {
    copySessions() {
        ClipboardState.copy();
    }

    pasteSessions() {
        ClipboardState.paste();
    }

    deleteSessions() {
        ClipboardState.showDeleteDialog();
    }

    getLabel(count) {
        let label = '';
        if (count === 0) {
            label = '0 Sessions';
        } else if (count === 1) {
            label = '1 Session';
        } else {
            label = count = count + ' Sessions';
        }
        return label;
    }

    render() {
        Console.render('CalendarContextMenu');
        const { selectedSessionCount, copiedSessionCount } = this.props;
        const selectedSessionLabel = this.getLabel(selectedSessionCount);
        const isDisabled = selectedSessionCount === 0;
        const copiedSessionLabel = this.getLabel(copiedSessionCount);
        const isPasteDisabled = copiedSessionCount === 0;

        let menuItems = [];
        menuItems.push(
            <Item key="i1" onClick={this.copySessions} disabled={isDisabled}>
                <ListItem>
                    <ListItemIcon>
                        <CopyIcon />
                    </ListItemIcon>
                    <ListItemText
                        inset
                        primary={'Copy ' + selectedSessionLabel}
                    />
                </ListItem>
            </Item>
        );
        menuItems.push(
            <Item
                key="i2"
                onClick={this.pasteSessions}
                disabled={isPasteDisabled}
            >
                <ListItem>
                    <ListItemIcon>
                        <PasteIcon />
                    </ListItemIcon>
                    <ListItemText
                        inset
                        primary={'Paste ' + copiedSessionLabel}
                    />
                </ListItem>
            </Item>
        );
        menuItems.push(
            <Item key="i3" onClick={this.deleteSessions} disabled={isDisabled}>
                <ListItem>
                    <ListItemIcon>
                        <DeleteIcon />
                    </ListItemIcon>
                    <ListItemText
                        inset
                        primary={'Delete ' + selectedSessionLabel}
                    />
                </ListItem>
            </Item>
        );

        return menuItems;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        selectedSessionCount: _.keys(state.clipboard.selectedSessions).length,
        copiedSessionCount: _.keys(state.clipboard.copiedSessions).length
    };
};

export default connect(mapStateToProps)(CalendarContextMenu);
